import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Validation from "../views/Validation.vue";
import Welcome from "../views/Welcome.vue";
import { setI18nLanguage, loadLocaleMessages, getPreferredLanguage } from "../i18n";

function getQueryParams(to) {
  let queryParams = {};
  const hasQuestionMarks = to.fullPath.match(/\?/g);
  if (!!hasQuestionMarks && hasQuestionMarks.length > 1) {
    const splitParams = to.fullPath.split(/[?&]/i);
    splitParams.forEach(param => {
      const splitParam = param.split("=");
      if (splitParam.length == 2) {
        queryParams[splitParam[0]] = splitParam[1];
      }
    });
  } else {
    queryParams = to.query;
  }
  return queryParams;
}

export function setupRouter(i18n) {
  const routes = [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/validation",
      name: "Validation",
      component: Validation,
    },
    {
      path: "/welcome",
      name: "Welcome",
      component: Welcome,
    },
  ];

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  router.beforeEach(async () => {
    let locale = getPreferredLanguage();

    if (!i18n.global.availableLocales.includes(locale)) {
      await loadLocaleMessages(i18n, locale);
    }

    setI18nLanguage(i18n, locale);
  });

  router.beforeResolve((to, from, next) => {
    const queryParams = getQueryParams(to);

    if (to.name === "Home" && queryParams.type_hint && (queryParams.type_hint === "PASSWORD_RECOVERY" || queryParams.type_hint === "EMAIL_VERIFICATION")) {
      next({ name: "Validation", query: queryParams });
    } else if (to.name === "Home") {
      next({ name: "Login", query: queryParams });
    } else {
      next();
    }
  });

  return router;
}
